import { useQuery } from '@tanstack/react-query'
import type { SipEngineOverview } from '@sbclite/core/container/api'
import { api } from '../services/api'
import { useAuth } from '../contexts/AuthContext'

export const sipEngineOverviewQueryKeys = {
  overview: (containerId: string) => ['sip-engine-overview', containerId] as const,
} as const

export function useSipEngineOverview(containerId: string | undefined) {
  const { user } = useAuth()
  return useQuery({
    queryKey: [...sipEngineOverviewQueryKeys.overview(containerId ?? ''), user?.id ?? 'anonymous'] as const,
    queryFn: async (): Promise<SipEngineOverview> => (await api.getSipEngineOverview(containerId ?? '')).data,
    enabled: !!containerId && user?.role === 'admin',
    refetchInterval: 15_000,
  })
}
